module.exports = __webpack_public_path__ + "files/f4b2098bc8ebe53098c87620952dabaf.png";